export enum SupportStatus {
    NEW = 'NEW',
    UPDATED = 'UPDATED',
    PROGRESS = 'PROGRESS',
    PENDING = 'PENDING',
    SOLVED = 'SOLVED',
    CLOSED = 'CLOSED'
}

export enum SupportTypes {
    INCIDENT = 'INCIDENT',
    REQUEST = 'REQUEST',
}